<template>
  <div>
    <section class="container-fluid my-4 col-md-10 offset-md-2">
      <h4 class="my-4">Agenda Semanal — <strong>Fluxos</strong></h4>

      <div class="mb-3 d-flex align-items-center gap-2">
        <input type="date" class="form-control" style="max-width:200px" v-model="referenceDate" />
        <button class="btn btn-primary btn-sm" @click="createFlow">+ Novo Fluxo</button>
      </div>

      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Início (Segunda)</th>
            <th>Fim (Domingo)</th>
            <th>Tarefas</th>
            <th width="140px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="flow in flows" :key="flow.id">
            <td>{{ flow.id }}</td>
            <td>{{ formatDate(flow.start_date) }}</td>
            <td>{{ formatDate(flow.end_date) }}</td>
            <td>{{ flow.flow_tasks ? flow.flow_tasks.length : 0 }}</td>
            <td>
              <router-link
                :to="{ name: 'weekly-flow-show', params: { id: flow.id } }"
                class="btn btn-sm btn-info mr-1"
              >Ver</router-link>
              <button class="btn btn-sm btn-danger" @click="deleteFlow(flow.id)">Excluir</button>
            </td>
          </tr>
          <tr v-if="flows.length === 0">
            <td colspan="5" class="text-center text-muted">Nenhum fluxo encontrado.</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import api from "@/services";

export default {
  name: "WeeklyFlowList",
  data() {
    return {
      flows: [],
      referenceDate: new Date().toISOString().substring(0, 10),
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const [y, m, d] = dateStr.substring(0, 10).split("-");
      return `${d}/${m}/${y}`;
    },
    async loadFlows() {
      const { data } = await api.get("/flows");
      this.flows = data;
    },
    async createFlow() {
      if (!this.referenceDate) {
        Toast.fire("Informe uma data de referência.", "", "warning");
        return;
      }
      try {
        const { data } = await api.post("/flows", { reference_date: this.referenceDate });
        Toast.fire(data.message, "", "success");
        this.loadFlows();
      } catch (error) {
        const msg = error.response?.data?.errors?.reference_date?.[0]
          || error.response?.data?.message
          || "Erro ao criar fluxo.";
        Toast.fire(msg, "", "error");
      }
    },
    async deleteFlow(id) {
      const result = await this.$swal({
        title: "Deseja confirmar a ação?",
        text: "O fluxo e todas as execuções de tarefas serão removidos!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apague!",
        cancelButtonText: "Cancelar",
      });
      if (!result.value) return;
      try {
        await api.delete(`/flows/${id}`);
        Toast.fire("Fluxo removido com sucesso.", "", "success");
        this.loadFlows();
      } catch (error) {
        Toast.fire(error.response?.data?.message || "Erro ao remover.", "", "error");
      }
    },
  },
  mounted() {
    this.loadFlows();
  },
};
</script>
